export default "/assets/Icon/Discord.svg"